<template>
    <div class="w-full">
        <div class="w-full mx-auto">
            <div class="w-full mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    PANTAU CCTV
                </h1>
            </div>
            <div class="md:grid md:grid-cols-12 gap-4 mt-8">
                <div
                    class="mt-4 col-span-6 border-2 border-primary rounded-xl h-[400px] bg-black"
                >
                    <video-js
                        id="cctv2"
                        class="image_cctv vjs-default-skin"
                        preload="auto"
                        autoplay
                        muted
                    >
                        <source
                            src="https://cctv.rsudsulfat.id/72558ca82011587c56456e76edda3cfe/hls/dhHh6o5ggF/xXWXZDd1Fu/s.m3u8"
                            type="application/x-mpegURL"
                        />
                    </video-js>
                </div>
                <div
                    class="mt-4 col-span-6 border-2 border-primary rounded-xl h-[400px] bg-black"
                >
                    <video-js
                        id="cctv1"
                        class="image_cctv vjs-default-skin"
                        preload="auto"
                        autoplay
                        muted
                    >
                        <source
                            src="https://cctv.rsudsulfat.id/72558ca82011587c56456e76edda3cfe/hls/dhHh6o5ggF/Bl1GQ2fraV/s.m3u8"
                            type="application/x-mpegURL"
                        />
                    </video-js>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import LayoutNoHeader from "../Shared/LayoutNoHeader.vue";
import RandomShape from "../Shared/RandomShape.vue";
import DateInput from "../Shared/DateInput.vue";
const videojs = window.videojs;
export default {
    components: {
        Link,
        RandomShape,
        DateInput,
    },
    data() {
        return {};
    },
    watch: {},
    props: {},
    methods: {},
    layout: LayoutNoHeader,
    mounted() {
        console.log('mounted');
        const player1 = videojs("cctv1");
        const player2 = videojs("cctv2");
    },
};
</script>

<style>
.image_cctv video {
    width: 100%;
    height: 100%;
}
</style>
